import { Button } from '@nike/eds'
import { dispatch } from 'api/redux'
import { showSnackbar } from 'components/snackbar'
import { useTranslation } from 'react-i18next'
import { type RASN, type RASNFamily } from 'types'
import { dateToLocalString } from 'utils/date'
import { type ApiHandlerContext } from 'utils/useApiHandler'

interface RasnDetailsPanelProps {
  goodsHolder: string | undefined
  goodsHolderTrackingId: string | undefined
  rasnData: RASN
  rasnFamilyData: RASNFamily | undefined
  processedQuantity: number
  finishRasnContext: () => void
  handlePauseCarton: () => void
  closeGoodsHolderContext: ApiHandlerContext<string>
  showReturnsEndDate: boolean
}

export const RasnRlpnDetailsPanel = ({ goodsHolder, goodsHolderTrackingId, rasnData, rasnFamilyData, processedQuantity, finishRasnContext, handlePauseCarton, closeGoodsHolderContext, showReturnsEndDate }: RasnDetailsPanelProps) => {
  const { t } = useTranslation()

  const closeCarton = () => {
    if (goodsHolder && !closeGoodsHolderContext.isLoading) {
      closeGoodsHolderContext.handleApiCall(goodsHolder)
        .then()
        .catch(err => {
          if (err.status !== 404) throw err // this case should never be reached, if so it's a bug so throw
          dispatch(showSnackbar(t('snackbar.unknown_rlpn', { rlpn: goodsHolder }), 'error'))
        })
    }
  }

  return <div className='flex flex-col flex-grow justify-between'>
    <div className="grid grid-cols-[4fr,6fr] gap-x-2 gap-y-6 h-fit text-3xl">
      <div className="font-bold">{t('detail_panel.rasn')}</div><div>{rasnFamilyData ? rasnFamilyData.number : rasnData.number}</div>
      {goodsHolder && <>
        <div className="font-bold">{t('detail_panel.goodsholder')}</div><div>{goodsHolder}</div>
        {goodsHolderTrackingId && <>
          <div className="font-bold">{t('detail_panel.tracking_id')}</div><div>{goodsHolderTrackingId}</div>
        </>}
      </>
      }
      <div className="font-bold">{t('detail_panel.customer')}</div><div>{rasnFamilyData ? rasnFamilyData.customerName : rasnData.customerName}</div>
      <div className={'font-bold'}>{t('detail_panel.customer_type')}</div><div>{rasnFamilyData ? rasnFamilyData.channel : rasnData.channel}</div>
      <div className="font-bold">{t('detail_panel.units_handled')}</div><div>{processedQuantity}</div>
      {showReturnsEndDate && <><div className="font-bold">{t('detail_panel.returns_window_date')}</div><div>{rasnFamilyData ? '' : dateToLocalString(rasnData.returnsEndDate)}</div></>}
    </div>
    {goodsHolder
      ? (
        <div className={'flex'}>
          <Button className="mx-auto text-2xl"
            onClick={closeCarton}
            disabled={processedQuantity === 0}
          >
            {t('buttons.close_carton')}
          </Button>
          <Button className="mx-auto text-2xl"
            onClick={handlePauseCarton}
            variant={'secondary'}
          >
            {t('buttons.pause_carton')}
          </Button>
        </div>
        )
      : (
          <Button id={'finishRASNButton'} className="mx-auto text-2xl"
            onClick={finishRasnContext}
          >
            {t('buttons.finish_rasn')}
          </Button>
        )}
  </div>
}
